'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENV = process.env.NODE_ENV;

function getMessage(message) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (message && (0, _isFunction2.default)(message)) {
    return message(values);
  }
  return void 0;
}

function formatMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


  if (!state.locale) {
    return function () {
      return '';
    };
  }

  return function () {
    var messageDescriptor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var id = messageDescriptor.id,
        defaultMessage = messageDescriptor.defaultMessage;


    var message = (0, _get2.default)(state, ['messages', id], '');

    if (ENV === 'production' && (0, _isEmpty2.default)(values)) {
      return getMessage(message) || defaultMessage || id;
    }

    if (!message && !defaultMessage) {
      !message ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, _constants.LOG_PREFIX + ' Missing message/defaultMessage: "' + id + '" for locale: "' + state.locale + '"') : (0, _invariant2.default)(false) : void 0;
      return id;
    }

    return getMessage(message, values) || defaultMessage;
  };
}

exports.default = formatMessage;


//////////////////
// WEBPACK FOOTER
// ./~/redux-intl-connect/lib/formatMessage.js
// module id = 327
// module chunks = 0